/**
 * Created by jv on 15/05/2018.
 */
export default class Obstacle extends Phaser.GameObjects.Sprite
{
  constructor(scene, x, y, key, frame)
  {
    super(scene, x, y, key, frame).setOrigin(0, 1);

    scene.children.add(this);
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/objects/obstacle.js